import { useSelector } from "react-redux";
import { ApplicationState } from "../rootStore";

export const useTemplateEmailNotificationReducer = () =>
	useSelector((state: ApplicationState) => state.templateEmailNotification);
